// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file device/device_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { MissingParamsError } from '../common/common_errors_pb';
import { file_common_common_errors } from '../common/common_errors_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import { file_error_error_model } from '../error/error_model_pb';
import type { Device } from './device_model_pb';
import { file_device_device_model } from './device_model_pb';

/**
 * Describes the file device/device_response.proto.
 */
export const file_device_device_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChxkZXZpY2UvZGV2aWNlX3Jlc3BvbnNlLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJ3Cg5EZXZpY2VSZXNwb25zZRIKCgJpZBgBIAEoAxIsCgZkZXZpY2UYAiABKAsyHC5jb20uZ2VtLmJmZi5jb250cmFjdC5EZXZpY2USEwoLY3JlYXRlZEF0VHMYAyABKAMSFgoObGFzdEFjdGl2aXR5VHMYBCABKAMiWAoSR2V0RGV2aWNlc1Jlc3BvbnNlEjoKB3N1Y2Nlc3MYASABKAsyJy5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXREZXZpY2VzU3VjY2Vzc0gAQgYKBHR5cGUiZAoYR2V0Q3VycmVudERldmljZVJlc3BvbnNlEkAKB3N1Y2Nlc3MYASABKAsyLS5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRDdXJyZW50RGV2aWNlU3VjY2Vzc0gAQgYKBHR5cGUiRwoXR2V0Q3VycmVudERldmljZVN1Y2Nlc3MSLAoGZGV2aWNlGAEgASgLMhwuY29tLmdlbS5iZmYuY29udHJhY3QuRGV2aWNlIqsBChhUZXJtaW5hdGVEZXZpY2VzUmVzcG9uc2USQAoHc3VjY2VzcxgBIAEoCzItLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlRlcm1pbmF0ZURldmljZXNTdWNjZXNzSAASQQoNbWlzc2luZ1BhcmFtcxgCIAEoCzIoLmNvbS5nZW0uYmZmLmNvbnRyYWN0Lk1pc3NpbmdQYXJhbXNFcnJvckgAOgIYAUIGCgR0eXBlIocBChFHZXREZXZpY2VzU3VjY2VzcxI7Cg1jdXJyZW50RGV2aWNlGAEgASgLMiQuY29tLmdlbS5iZmYuY29udHJhY3QuRGV2aWNlUmVzcG9uc2USNQoHZGV2aWNlcxgCIAMoCzIkLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkRldmljZVJlc3BvbnNlIjAKF1Rlcm1pbmF0ZURldmljZXNTdWNjZXNzEhEKCWRldmljZUlkcxgBIAMoCToCGAEiYgoXU2V0RGV2aWNlU3RhdHVzUmVzcG9uc2USPwoHc3VjY2VzcxgBIAEoCzIsLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlNldERldmljZVN0YXR1c1N1Y2Nlc3NIAEIGCgR0eXBlIisKFlNldERldmljZVN0YXR1c1N1Y2Nlc3MSEQoJZGV2aWNlSWRzGAIgAygJQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [
      file_device_device_model,
      file_common_common_errors,
      file_common_common_responses,
      file_error_error_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.DeviceResponse
 */
export type DeviceResponse = Message<'com.gem.bff.contract.DeviceResponse'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: com.gem.bff.contract.Device device = 2;
   */
  device?: Device;

  /**
   * @generated from field: int64 createdAtTs = 3;
   */
  createdAtTs: bigint;

  /**
   * @generated from field: int64 lastActivityTs = 4;
   */
  lastActivityTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.DeviceResponse.
 * Use `create(DeviceResponseSchema)` to create a new message.
 */
export const DeviceResponseSchema: GenMessage<DeviceResponse> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 0);

/**
 * @generated from message com.gem.bff.contract.GetDevicesResponse
 */
export type GetDevicesResponse = Message<'com.gem.bff.contract.GetDevicesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetDevicesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDevicesSuccess success = 1;
         */
        value: GetDevicesSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetDevicesResponse.
 * Use `create(GetDevicesResponseSchema)` to create a new message.
 */
export const GetDevicesResponseSchema: GenMessage<GetDevicesResponse> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 1);

/**
 * @generated from message com.gem.bff.contract.GetCurrentDeviceResponse
 */
export type GetCurrentDeviceResponse = Message<'com.gem.bff.contract.GetCurrentDeviceResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetCurrentDeviceResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCurrentDeviceSuccess success = 1;
         */
        value: GetCurrentDeviceSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetCurrentDeviceResponse.
 * Use `create(GetCurrentDeviceResponseSchema)` to create a new message.
 */
export const GetCurrentDeviceResponseSchema: GenMessage<GetCurrentDeviceResponse> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 2);

/**
 * @generated from message com.gem.bff.contract.GetCurrentDeviceSuccess
 */
export type GetCurrentDeviceSuccess = Message<'com.gem.bff.contract.GetCurrentDeviceSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.Device device = 1;
   */
  device?: Device;
};

/**
 * Describes the message com.gem.bff.contract.GetCurrentDeviceSuccess.
 * Use `create(GetCurrentDeviceSuccessSchema)` to create a new message.
 */
export const GetCurrentDeviceSuccessSchema: GenMessage<GetCurrentDeviceSuccess> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 3);

/**
 * Deprecated: use SetDeviceStatusRequest(DELETED) instead
 *
 * @generated from message com.gem.bff.contract.TerminateDevicesResponse
 * @deprecated
 */
export type TerminateDevicesResponse = Message<'com.gem.bff.contract.TerminateDevicesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.TerminateDevicesResponse.type
   * @deprecated
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.TerminateDevicesSuccess success = 1;
         */
        value: TerminateDevicesSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MissingParamsError missingParams = 2;
         */
        value: MissingParamsError;
        case: 'missingParams';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.TerminateDevicesResponse.
 * Use `create(TerminateDevicesResponseSchema)` to create a new message.
 * @deprecated
 */
export const TerminateDevicesResponseSchema: GenMessage<TerminateDevicesResponse> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 4);

/**
 * @generated from message com.gem.bff.contract.GetDevicesSuccess
 */
export type GetDevicesSuccess = Message<'com.gem.bff.contract.GetDevicesSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.DeviceResponse currentDevice = 1;
   */
  currentDevice?: DeviceResponse;

  /**
   * @generated from field: repeated com.gem.bff.contract.DeviceResponse devices = 2;
   */
  devices: DeviceResponse[];
};

/**
 * Describes the message com.gem.bff.contract.GetDevicesSuccess.
 * Use `create(GetDevicesSuccessSchema)` to create a new message.
 */
export const GetDevicesSuccessSchema: GenMessage<GetDevicesSuccess> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 5);

/**
 * Deprecated: use SetDeviceStatusRequest(DELETED) instead
 *
 * @generated from message com.gem.bff.contract.TerminateDevicesSuccess
 * @deprecated
 */
export type TerminateDevicesSuccess = Message<'com.gem.bff.contract.TerminateDevicesSuccess'> & {
  /**
   * @generated from field: repeated string deviceIds = 1;
   */
  deviceIds: string[];
};

/**
 * Describes the message com.gem.bff.contract.TerminateDevicesSuccess.
 * Use `create(TerminateDevicesSuccessSchema)` to create a new message.
 * @deprecated
 */
export const TerminateDevicesSuccessSchema: GenMessage<TerminateDevicesSuccess> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 6);

/**
 * @generated from message com.gem.bff.contract.SetDeviceStatusResponse
 */
export type SetDeviceStatusResponse = Message<'com.gem.bff.contract.SetDeviceStatusResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.SetDeviceStatusResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetDeviceStatusSuccess success = 1;
         */
        value: SetDeviceStatusSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.SetDeviceStatusResponse.
 * Use `create(SetDeviceStatusResponseSchema)` to create a new message.
 */
export const SetDeviceStatusResponseSchema: GenMessage<SetDeviceStatusResponse> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 7);

/**
 * @generated from message com.gem.bff.contract.SetDeviceStatusSuccess
 */
export type SetDeviceStatusSuccess = Message<'com.gem.bff.contract.SetDeviceStatusSuccess'> & {
  /**
   * @generated from field: repeated string deviceIds = 2;
   */
  deviceIds: string[];
};

/**
 * Describes the message com.gem.bff.contract.SetDeviceStatusSuccess.
 * Use `create(SetDeviceStatusSuccessSchema)` to create a new message.
 */
export const SetDeviceStatusSuccessSchema: GenMessage<SetDeviceStatusSuccess> =
  /*@__PURE__*/
  messageDesc(file_device_device_response, 8);
